import { combineReducers } from 'redux';
import auth from './auth/reducer';
import menu from './menu/reducer';
import settings from './settings/reducer';
import user from './user/reducer';
var reducers = combineReducers({
    menu: menu,
    settings: settings,
    auth: auth,
    user: user,
});
export default reducers;
